import { number } from "echarts";

export function tableConfig () {
  return {
    // 转融通
    refinancingConfig: {
      labelWidth: 150,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [{
        label: '项目类型',
        prop: 'projectTypeStr',
        disabled: true,
        rules: [
          {
            required: true,
            message: '请选择项目'
          }
        ]
      },{
        label: '借券机构',
        prop: 'securitiesInstitution',
        rules: [
          {
            required: true,
            message: '请输入项目名称'
          }
        ]
      },{
        label: '借券标的',
        prop: 'securitiesObject',
        rules: [
          {
            required: true,
            message: '请输入借券标的'
          }
        ]
      },{
        label: '借券股数',
        prop: 'securitiesNum',
        append: '万股',
        rules: [
          {
            required: true,
            message: '请输入借券股数'
          }
        ]
      },
      // {
      //   label: '证券公司',
      //   // prop: 'securitiesCompany',
      //   prop: 'custId',
      //   type: "select",
      //   dicUrl: '/api/blade-/zd/custom/dict',
      //   dicMethod:'post',
      //   dicQuery:{
      //     custType: 3
      //   },
      //   props: {
      //     label: 'dictValue',
      //     value: 'dictKey'
      //   },        
      //   rules: [
      //     {
      //       required: true,
      //       message: '请选择证券公司'
      //     }
      //   ]
      // },
      {
        label: '年化利率',
        prop: 'arr',
        append: '%',
        rules: [
          {
            required: true,
            message: '请输入年化利率'
          }
        ]
      },{
        label: '出借日收盘价',
        prop: 'lendingDayPrice',
        append: '元',
        rules: [
          {
            required: true,
            message: '请输入出借日收盘价'
          }
        ]
      },{
        label: '实际出借天数',
        append: '天',
        prop: 'realLendingDays',
        rules: [
          {
            required: true,
            message: '请输入证券数量'
          }
        ]
      },{
        label: '起始日期',
        type: 'date',
        valueFormat: "yyyy-MM-dd",
        prop: 'lendingDate',
        rules: [
          {
            required: true,
            message: '请选择起始日期'
          }
        ]
        // formatter: (row, value, label, column) => {
        //   console.info(row, value, label, column, 'shouyeeeee')
        // },
      },{
        label: '还券日期',
        type: 'date',
        valueFormat: 'yyyy-MM-dd',
        prop: 'repaymentDate',
        rule: [
          {
            require: true,
            message: '请选择还券日期'
          }
        ]
      },{
        label: '转融通利息收入',
        append: '元',
        prop: 'interest'
        // rules: [
        //   {
        //     required: true,
        //     message: '请输入转融通利息收入'
        //   }
        // ]
      },{
        label: '权益补偿金',
        append: '元',
        prop: 'compensation',
        // rules: [
        //   {
        //     required: true,
        //     message: '请输入转融通利息收入'
        //   }
        // ]
      },{
        label: '附件',
        prop: 'files',
        formslot:true,
        span: 12
      },{
        label: '备注',
        prop: 'remarks',
        type: 'textarea',
        span: 24      
      }]
    },
    // 委托贷款/信托
    loanInstitutionConfig: {
      labelWidth: 150,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [{
        label: '项目类型',
        prop: 'projectTypeStr',
        disabled: true,
        rules: [
          {
            required: true,
            message: '请选择项目'
          }
        ]        
      },{
        label: '项目名称',
        prop: 'name',
        rules: [
          {
            required: true,
            message: '请输入项目名称'
          }
        ]
      },{
        label: '融资方',
        prop: 'custId',
        type: "select",
        dicUrl: '/api/blade-/zd/custom/dict',
        dicMethod:'post',
        dicQuery:{
          custType: 3
        },
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },
        rules: [
          {
            required: true,
            message: '请选择融资方'
          }
        ]
      },{
        label: '出资方',
        prop: 'investorId',
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=investor",
        props: {
          label: 'dictValue',
          value: 'dictKey'
        },
        rules: [
          {
            required: true,
            message: '请选择出资方',
            trigger: "change",
          },
        ]
      },{
        label: '投放金额',
        prepend: '￥',
        append: '万元',
        prop: 'creditNum',
        rules: [
          {
            required: true,
            message: '请输入投放金额'
          }
        ]
      },
      {
        label: '经办人',
        disabled: true,
        prop: 'userName',
        rules: [
          {
            required: true,
            message: '请选择经办人'
          }
        ]
      },{
        label: '年化收益率',
        append:'%',
        // type: 'number',
        prop: 'arr',
        rules: [
          {
            required: true,
            message: '请输入年华利率'
          }
        ]        
      },{
        label: '资金用途',
        prop: 'useType',
        rules: [
          {
            required: true,
            message: '请输入资金用途'
          }
        ]
      },{
        label: '还款来源',
        prop: 'repaymentSource',
        rules: [
          {
            required: true,
            message: '请输入还款来源'
          }
        ]
      },{
        label: '附件',
        prop: 'files',
        formslot:true,
        span: 12
      },
      {
        label: '还款明细',
        formslot: true,
        prop: 'repayLimit',
        span: 24
      },      
      // {
      //   label: '还款方式',
      //   prop: 'repaymentType',
      //   type: 'textarea',
      //   span: 24,
      //   rules: [
      //     {
      //       required: true,
      //       message: '请输入还款方式'
      //     }
      //   ]
      // },
      {
        label: '增信措施',
        prop: 'creditEnhancement',
        type: 'textarea',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入增信措施'
          }
        ]        
      },{
        label: '备注',
        prop: 'remarks',
        type: 'textarea',
        span: 24
      }]      
    },
    // 定增
    setTheGainConfig: {
      labelWidth: 150,
      gutter: 20,
      submitBtn: false,
      emptyBtn: false,
      column: [{
        label: '项目类型',
        prop: 'projectTypeStr',
        disabled: true,
        rules: [
          {
            required: true,
            message: '请选择项目'
          }
        ]        
      },{
        label: '项目名称',
        prop: 'name',
        rules: [
          {
            required: true,
            message: '请输入项目名称'
          }
        ]
      },{
        label: '证券编号',
        prop: 'securitiesNo',
        rules: [
          {
            required: true,
            message: '请输入证券编号'
          }
        ]
      },{
        label: '证券名称',
        prop: 'securitiesName',
        rules: [
          {
            required: true,
            message: '请输入证券名称'
          }
        ]
      },{
        label: '拟参与的价值',
        prepend: '￥',
        prop: 'planValue',
        rules: [
          {
            required: true,
            message: '请输入拟参与的价值'
          }
        ]
      },{
        label: '拟参与的数量',
        prop: 'planNum',
        // rules: [
        //   {
        //     required: true,
        //     message: '请输入拟参与的数量'
        //   }
        // ]
      },{
        label: '实际中标价值',
        prepend: '￥',
        prop: 'actualValue',
        rules: [
          {
            required: true,
            message: '请输入实际中的价值'
          }
        ]
      },{
        label: ' 实际中标数量',
        prop: 'actualNum',
        rules: [
          {
            required: true,
            message: '请输入实际中标的数量'
          }
        ]
      },{
        label: '经办人',
        disabled: true,
        prop: 'userName',
        rules: [
          {
            required: true,
            message: '请选择经办人'
          }
        ]        
      },{
        label: '附件',
        prop: 'files',
        formslot:true,
        span: 12
      },{
        label: '备注',
        prop: 'remarks',
        type: 'textarea',
        span: 24          
      }]      
    }
  }
}